import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoaderService } from '../../../../../components/loader/loader.service';
import { LOADER_TYPE, Loader } from '../../../../../components/loader/loader.model';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'demo-loader',
  standalone: true,
  imports: [CommonModule, LocalLoaderComponent],
  templateUrl: './demo-loader.component.html',
  styleUrl: './demo-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoLoaderComponent {
  localLoaderIsActive$ = new BehaviorSubject('false');

  constructor(private loaderService: LoaderService) {}

  startProgress() {
    let counter = 0;

    const progress = () => {
      counter += 10;

      const loaderConfig: Loader = {
        status: true,
        type: LOADER_TYPE.PROGRESS,
        value: counter,
        text: `Loading ${counter} / 100...`,
      };

      this.loaderService.init(loaderConfig);

      if (counter === 100) {
        clearInterval(progresAction);

        loaderConfig.text = `Complete..`;
        this.loaderService.init(loaderConfig);

        setTimeout(() => {
          loaderConfig.status = false;
          this.loaderService.init(loaderConfig);
        }, 500);
      }
    };

    const progresAction = setInterval(progress, 500);
  }

  startInifiniteLoader() {
    const loaderConfig: Loader = {
      status: true,
      type: LOADER_TYPE.INFINITE,
    };

    this.loaderService.init(loaderConfig);

    setTimeout(() => {
      loaderConfig.status = false;
      this.loaderService.init(loaderConfig);
    }, 2000);
  }

  startLocalLoader() {
    this.localLoaderIsActive$.next('true');

    setTimeout(() => {
      this.localLoaderIsActive$.next('false');
    }, 2000);
  }
}
